import script from "./ChKit.vue?vue&type=script&setup=true&lang=js"
export * from "./ChKit.vue?vue&type=script&setup=true&lang=js"

import "./ChKit.vue?vue&type=style&index=0&id=73fe4a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fe4a2a"]])

export default __exports__